<template>
  <!-- DASHBOARD -->
    <b-container fluid>
      <template v-if="!showKpis && !showKpisGraficos">
        <div class="no-access">
          <div class="no-access-c">
            <img class="no-access-img" :src="require(`@/assets/no-access.png`)" alt="Sem acesso" width="100" />
            <p>Seu usuário não possui acesso para visualizar esta tela.</p>
          </div>
        </div>
      </template>
      <span v-show="showKpis || showKpisGraficos">
        <el-row>
          <VueAffixBox :offset-top="60">
            <el-col :span="24">
              <!-- FILTRO -->
              <div class="grid-content">
                <DashboardFiltro v-if="showKpis || showKpisGraficos" />
              </div>
            </el-col>
          </VueAffixBox>
        </el-row>
        <el-row :gutter="20" v-if="showKpis">
          <el-col
            :xs="24"
            :sm="12"
            :md="6"
            :lg="6"
            :xl="6"
          >
            <div class="grid-content">
              <DashboardCard
                :datas="dataDashboard && dataDashboard.kpis ? dataDashboard.kpis[0] : {}"
                :id="idsCards[0]"
                color="#10B2EF"
                :listaModelo="optionsModeloDre"
                :loadParent="loadingDash"
              />
            </div>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="6"
            :lg="6"
            :xl="6"
          >
            <div class="grid-content">
              <DashboardCard
                :datas="dataDashboard && dataDashboard.kpis ? dataDashboard.kpis[1] : {}"
                :id="idsCards[1]"
                color="#FC326F"
                :listaModelo="optionsModeloDre"
                :loadParent="loadingDash"
              />
            </div>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="6"
            :lg="6"
            :xl="6"
          >
            <div class="grid-content">
              <DashboardCard
                :datas="dataDashboard && dataDashboard.kpis ? dataDashboard.kpis[2] : {}"
                :id="idsCards[2]"
                color="#032498"
                :listaModelo="optionsModeloDre"
                :loadParent="loadingDash"
              />
            </div>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="6"
            :lg="6"
            :xl="6"
          >
            <div class="grid-content">
              <DashboardCard
                :datas="dataDashboard && dataDashboard.kpis ? dataDashboard.kpis[3] : {}"
                :id="idsCards[3]"
                color="#FF8000"
                :listaModelo="optionsModeloDre"
                :loadParent="loadingDash"
              />
            </div>
          </el-col>
        </el-row>
        <el-row v-if="showKpisGraficos && (dataCluster.length && filtros.tipo !== '')">
          <el-col :span="24">
            <!-- SEGUNDO FILTRO -->
            <div class="grid-content">
              <DashboardFiltro2 />
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-loading="loadingCharts" v-if="showKpisGraficos && (dataCluster.length && filtros.tipo !== '')">
          <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16"
          >
            <div class="grid-content">
            <Chart
              :datas="dataDashboard && dataDashboard.graficos ? dataDashboard.graficos[0] : {}"
              :id="idsCards[0]"
              tipoChart="1"
              :colors="['#10B2EF', '#61b73c', '#cf9e10', '#dd68ef']"
              :loadParent="loadingDash"
              :description="descriptionChart1"
            />
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"
          >
            <div class="grid-content">
            <Chart
              :datas="dataDashboard && dataDashboard.graficos ? dataDashboard.graficos[1] : {}"
              :id="idsCards[0]"
              tipoChart="2"
              :colors="['#10B2EF', '#61b73c', '#cf9e10', '#dd68ef']"
              :loadParent="loadingDash"
              :description="descriptionChart2"
            />
            </div>
          </el-col>

          <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16"
          >
            <div class="grid-content">
            <Chart
              :datas="dataDashboard && dataDashboard.graficos ? dataDashboard.graficos[2] : {}"
              :id="idsCards[1]"
              tipoChart="1"
              :colors="['#FC326F', '#61b73c', '#cf9e10', '#dd68ef']"
              :loadParent="loadingDash"
              :description="descriptionChart1"
            />
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"
          >
            <div class="grid-content">
            <Chart
              :datas="dataDashboard && dataDashboard.graficos ? dataDashboard.graficos[3] : {}"
              :id="idsCards[1]"
              tipoChart="2"
              :colors="['#FC326F', '#61b73c', '#cf9e10', '#dd68ef']"
              :loadParent="loadingDash"
              :description="descriptionChart2"
            />
            </div>
          </el-col>

          <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16"
          >
            <div class="grid-content">
            <Chart
              :datas="dataDashboard && dataDashboard.graficos ? dataDashboard.graficos[4] : {}"
              :id="idsCards[2]"
              tipoChart="1"
              :colors="['#032498', '#61b73c', '#cf9e10', '#dd68ef']"
              :loadParent="loadingDash"
              :description="descriptionChart1"
            />
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"
          >
            <div class="grid-content">
            <Chart
              :datas="dataDashboard && dataDashboard.graficos ? dataDashboard.graficos[5] : {}"
              :id="idsCards[2]"
              tipoChart="2"
              :colors="['#032498', '#61b73c', '#cf9e10', '#dd68ef']"
              :loadParent="loadingDash"
              :description="descriptionChart2"
            />
            </div>
          </el-col>

          <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16"
          >
            <div class="grid-content">
            <Chart
              :datas="dataDashboard && dataDashboard.graficos ? dataDashboard.graficos[6] : {}"
              :id="idsCards[3]"
              tipoChart="1"
              :colors="['#FF8000', '#61b73c', '#cf9e10', '#dd68ef']"
              :loadParent="loadingDash"
              :description="descriptionChart1"
            />
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"
          >
            <div class="grid-content">
            <Chart
              :datas="dataDashboard && dataDashboard.graficos ? dataDashboard.graficos[7] : {}"
              :id="idsCards[3]"
              tipoChart="2"
              :colors="['#FF8000', '#61b73c', '#cf9e10', '#dd68ef']"
              :loadParent="loadingDash"
              :description="descriptionChart2"
            />
            </div>
          </el-col>

        </el-row>
        <el-row :gutter="20" v-loading="loadingCharts" v-if="showKpisGraficos && (!dataCluster.length || filtros.tipo === '')">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="10">
            <div v-if="temAcesso('IndiceDeGestao','Obter')" class="grid-content">
              <DashboardIg v-if="igPermitidos()" :igData="igData" />
              <DashboardAviso v-else />
            </div>
          </el-col>
          <el-col v-if="temAcesso('Cluster')" :xs="24" :sm="24" :md="24" :lg="12" :xl="14">
            <div class="grid-content">
              <DashboardClusterCard :dataCluster="dataCluster" />
            </div>
          </el-col>
        </el-row>
      </span>
    </b-container>
</template>

<script>
import DashboardFiltro from "@/components/Dashboard/Filtro";
import DashboardFiltro2 from "@/components/Dashboard/Filtro2";
import DashboardAviso from "@/components/Dashboard/Aviso";
import DashboardIg from "@/components/Dashboard/Ig";
import DashboardCard from "@/components/Dashboard/Card";
import DashboardClusterCard from "@/components/Dashboard/ClusterCard";
import VueAffixBox from 'vue-affix-box';

// import {chartsMock} from '@/components/Dashboard/chart/mock.js';
import Chart from '@/components/Dashboard/chart/Chart';

import { mapState } from 'vuex';

export default {
  components: {
    DashboardFiltro,
    DashboardFiltro2,
    DashboardCard,
    VueAffixBox,
    Chart,
    DashboardAviso,
    DashboardIg,
    DashboardClusterCard
  },
  name: 'Dashboard',
  data: () => {
    return {
      showKpis: false,
      showKpisGraficos: false,
      showAdmin: false,
      dataCluster: [],
      loadingCharts: false,
      loadingDash: false,
      igLoading: false,
      igData: [],
      idsCards: [],
      paramsFiltros: {},
      dataDashboard: {},
      optionsModeloDre: [],
      descriptionChart1: 'Top 7',
      descriptionChart2: 'Comparativo com a loja referência'
    };
  },
  methods: {
    async listaCluster(){ // listagem tabela de clusters
        this.loadingCharts = true;

        let response = await this.axios.get(this.$urls.CLUSTER_LISTAR);

        this.loadingCharts = false;

        if(response.status !== 200) {
            return;
        }

        this.dataCluster = response.data;
    },
    async gerarIdsKpi () {
        let response = await this.axios.get(this.$urls.KPIS);

        if(response.status !== 200) {
            return;
        }

        this.idsCards = response.data;
    },
    async pegarDashboard () {
      this.loadingDash = true;
      let response = await this.axios.get(this.$urls.PEGAR_DASHBOARD,{
        params: this.paramsFiltros
      });

      this.loadingDash = false;
      if(response.status !== 200) {
          return;
      }

      this.dataDashboard = response.data;
      this.idsCards = response.data.kpis.map(ar => ar._id);
    },
    formatValuesFilter(filtros) {
        this.paramsFiltros = {};

        const formatarDataInicial = (data) => this.moment(data).startOf('month').format('YYYY-MM-DD');
        const formatarDataFinal = (data) => this.moment(data).endOf('month').format('YYYY-MM-DD');

        // Adiciona datas ao filtro
        if (filtros.datas?.length) {
            this.paramsFiltros.DataInicial = formatarDataInicial(filtros.datas[0]);
            this.paramsFiltros.DataFinal = formatarDataFinal(filtros.datas[1]);
        }

        // Adiciona datas2 ao filtro
       /*  if (filtros.datas2?.length) {
            this.paramsFiltros.DataInicial2 = formatarData(filtros.datas2[0]);
            this.paramsFiltros.DataFinal2 = formatarData(filtros.datas2[1]);
        } */

        // Adiciona tipo ao filtro
        if (filtros.tipo) {
            const key = filtros.selectedGroup ? 'Cluster._id' : 'Grupo._id';
            this.paramsFiltros[key] = filtros.tipo;
        }

        // Adiciona grupo ao filtro
        if (filtros.grupo) {
            this.paramsFiltros['Loja._id'] = filtros.grupo;
        }

        // Adiciona comparativo ao filtro
        if (filtros.comparativo) {
            this.paramsFiltros.comparativo = filtros.comparativo;
        }
    },

    async getModeloDre() {
      let response = await this.axios.get(this.$urls.DRE_MODELOS);

      if(!response.data.length) {
          return;
      }

      this.optionsModeloDre = response.data;
    },
    chamarFiltros() {
      if(this.showKpis || this.showKpisGraficos) {
        this.formatValuesFilter(this.filtros);
        this.pegarDashboard();
      }
    },
    async getIgTotal() {
      try {
          this.igLoading = true;

          const response = await this.axios.get(this.$urls.IG_OBTER_TOTAL, {
              params: {
                apenasTotal: true,
              }
          });
          
          if(response.status !== 200){
              this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
              return;
          }
          
          this.igData = response.data;
          this.trackingF360(this, 'Home','IG total');
      } catch(err) {

        console.error(err)
          this.$notify.error({
              title: 'Erro interno',
              message: `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
              position:'top-left'
          });
      }finally {
        this.igLoading = false
      }
    },
  },
  computed: {
		filtros: {
        get() {
            return this.$store.state.filtros;
        },
        set(value) {
            this.$store.commit('updateFiltros', value);
        }
    },
    user: {
        get() {
            return this.$store.state.user;
        },
        set(value) {
            this.$store.commit('updateUser', value);
        }
    },
    ...mapState(['acessos'])
	},
  watch: {
      // alterações do filtros principal
      'filtros.datas': {
        deep: true,
        handler() {
          this.chamarFiltros();
          this.filtros.datas2 = []
        }
      },
      'filtros.selectedGroup': function() {
        this.chamarFiltros();
      },
      'filtros.tipo': function() {
        this.chamarFiltros();
      },
      user: {
        deep: true,
        handler() {
          // alterado provisóriamente para remover dash
          // if(user.email === 'admin@boticario.com.br'){

          this.showKpis = this.acessos.find(r => r.name === 'Kpi');
          this.showKpisGraficos = this.acessos.find(r => r.name === 'KpiGrafico');

          if(this.acessos.length && this.acessos.find(r => r.name === 'sysAdmin')) {
            this.showKpis = true;
            this.showKpisGraficos = true;
          }

          this.showAdmin = true;
          
          this.formatValuesFilter(this.filtros);
          this.listaCluster();
        }
      }
  },
  mounted() {
    var getUser = JSON.parse(localStorage.getItem('user')) || {}
		this.user = getUser.user;
    this.getModeloDre();

    if(this.igPermitidos() && this.temAcesso('IndiceDeGestao', 'Obter')) {
      this.getIgTotal();
    }
  }
}
</script>
<style lang="scss" scoped>
.color-blue {
  color: #16223d;
}
.el-row {
  .el-col {
    margin-bottom: 1rem;
  }
  &:last-child {
    margin-bottom: 0;
  }
}
.grid-content {
  border-radius: 5px;
  background: #fff;
  min-height: 36px;
  box-shadow: 1px 2px 1px #d3d3d3;
}
.no-access {
    text-align: center;
    background: #fff;
    border-radius: 4px;
    width:100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    
    img.no-access-img {
      width: 250px;
      margin-top:-40px;
    }
    p {
      font-weight: 600;
      color: #2e2e2e;
    }
}
</style>
